/**
 * PostHog Identity
 *
 * Builds consistent PostHog user identity payloads.
 *
 * Primary responsibilities:
 * - Normalize auth user identity properties
 * - Keep client and server identify calls aligned
 *
 * Dependencies:
 * - None
 */

export type PostHogIdentityInput = {
  userId: string | null | undefined
  email?: string | null
  plan?: string | null
  createdAt?: string | null
  workspaceId?: string | null
}

export type PostHogIdentityProperties = {
  email?: string
  plan: string
  created_at?: string
  workspace_id?: string
}

const DEFAULT_PLAN = 'free'

// --------------

const readTrimmedString = (value: string | null | undefined) => {
  if (typeof value !== 'string') {
    return null
  }

  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

// --------------

export const readPostHogIdentityUserId = (input: PostHogIdentityInput) =>
  readTrimmedString(input.userId)

// --------------

export function buildPostHogIdentityProperties(
  input: PostHogIdentityInput
): PostHogIdentityProperties {
  const email = readTrimmedString(input.email)
  const plan = readTrimmedString(input.plan) ?? DEFAULT_PLAN
  const createdAt = readTrimmedString(input.createdAt)
  const workspaceId = readTrimmedString(input.workspaceId)

  return {
    ...(email ? { email } : {}),
    plan,
    ...(createdAt ? { created_at: createdAt } : {}),
    ...(workspaceId ? { workspace_id: workspaceId } : {})
  }
}
